import { canvasLabelMeasurer } from '@ardoq/graph-labeling';
import { Font } from './props';
import { LABEL_ICON_GAP, LABEL_ICON_SIZE } from './svg';

const measurers = new Map<string, (text: string) => number>();

const measureTextWidth = (font: Font, text: string): number => {
  const cssFont = `${font.weight} ${font.size}px ${font.family}`;
  let measurer = measurers.get(cssFont);
  if (!measurer) {
    measurer = canvasLabelMeasurer(cssFont);
    measurers.set(cssFont, measurer);
  }
  return measurer(text);
};

type LabelFootprintArgs = {
  font: Font;
  text: string;
  hasIcon: boolean;
  iconSize?: { width: number; height: number };
};

export const labelFootprint = ({
  font,
  text,
  hasIcon,
  iconSize,
}: LabelFootprintArgs): { width: number; height: number } => {
  const iconW = iconSize?.width ?? LABEL_ICON_SIZE;
  const iconH = iconSize?.height ?? LABEL_ICON_SIZE;
  const textWidth = measureTextWidth(font, text);
  return {
    width: textWidth + (hasIcon ? iconW + LABEL_ICON_GAP : 0),
    height: hasIcon ? Math.max(font.size, iconH) : font.size,
  };
};
